import { getContext } from '@fiverr-private/fiverr_context';
import { localStorage } from '@fiverr-private/futile';
import { JobPost } from '../../../types';

export interface JobPostMatchState {
    jobPost: JobPost;
    isOpen: boolean;
}

const buildKey = (userId: string | number | undefined) => `JOB_POST_MATCH_${userId}`;

export const readState = (): Partial<JobPostMatchState> => {
    const { userId } = getContext();
    const state = localStorage.get(buildKey(userId));

    return state || {};
};

export const persistState = (state: JobPostMatchState): void => {
    const { userId } = getContext();

    localStorage.set(buildKey(userId), state);
};
